import { action_buttons_defaults } from './buttons';
import { form_defaults } from './forms';
import { screen_defaults } from './screens';
import { column_defaults } from './tables';
import { table_defaults } from './tables/templates';
import { toolbar_defaults } from './toolbars';

export const component_defaults = {
  table: table_defaults,
  column: column_defaults,
  button: action_buttons_defaults,
  screen: screen_defaults,
  form: form_defaults,
  toolbar: toolbar_defaults,
};
